import { apiUrl } from "../components/LoginSignup";

export const updateBookingStage = async ({
  bookingId,
  stageId,
  status,
  userSession,
}) => {
  const response = await fetch(`${apiUrl}/booking/${bookingId}/stages`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      authorization: userSession.token,
      "user-role": userSession.user_role,
      "user-name": userSession.name || userSession.user_name || "Unknown",
    },
    body: JSON.stringify({
      stage_id: stageId,
      status,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Failed to update booking stage.");
  }

  return data;
};
